 export function prettifyDate(stringDate) {
    if(stringDate == null) {
        return "-";
    }
    let date = Date.parse(stringDate);
    return new Intl.DateTimeFormat('en-GB', { dateStyle: 'short'}).format(date);
}

export function prettifyDateTime(stringDate) {
    if(stringDate == null) {
        return "-";
    }
    let date = Date.parse(stringDate);
    return new Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeStyle: 'short'}).format(date);
}

export function prettifyMoney (amount) {
    if(amount == null) {
        return "-";
    }
    return `${(amount/100).toFixed(2)} €`;
}

 export function getSelectedUnitId(store) {
     if (isNaN(store.state.globalUnitId)) {
         store.state.globalUnitId = store.state.userInfo.orgMember.orgUnit.id;
     }
     return Number(store.state.globalUnitId);
 }

 export function hasRole (userInfo, roles) {
    if (roles == null){
         return true;
     }
     if (userInfo.roles.length < 1) {
         return false;
     }
     let res = false;
     roles.push("ADMIN");
     userInfo.roles.forEach(role => {
         if(roles.includes(role.name)) {
             res = true;
             return false; // Exit the forEach loop
         }
     });
     return res;
 }
